"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4599],{

/***/ 58441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var hooks_ielts_useDemoAlias__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36728);



var HeadingIeltsElite = function(param) {
    var _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "20px" : _fontSize;
    var isMasterclassAlias = (0,hooks_ielts_useDemoAlias__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMasterclassAlias;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
        className: "font-bold text-[".concat(fontSize, "] text-center mt-8 flex-grow"),
        children: [
            isMasterclassAlias ? "Join Free" : "Book your",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "bg-gradient-to-r from-[#635EFF] via-[#663CFF] to-[#5200FF] text-white px-3 rounded-3 inline-block skew-x-[-10deg]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "inline-block skew-x-[10deg]",
                    children: "IELTS"
                })
            }),
            " ",
            "MasterClass"
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadingIeltsElite);


/***/ }),

/***/ 94599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IeltsOnboardingForms_IeltsEliteProgressiveForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(33681);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 13 modules
var makeStyles = __webpack_require__(26472);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./public/static/scss/LeadCaptureLayout.module.scss
var LeadCaptureLayout_module = __webpack_require__(97506);
var LeadCaptureLayout_module_default = /*#__PURE__*/__webpack_require__.n(LeadCaptureLayout_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Ielts/IeltsEliteDemo/HeadingIeltsElite.tsx
var HeadingIeltsElite = __webpack_require__(58441);
// EXTERNAL MODULE: ./components/Ielts/IeltsOnboardingForms/utils.ts
var utils = __webpack_require__(11403);
// EXTERNAL MODULE: ./components/Inputs/CustomInputSelect.tsx + 1 modules
var CustomInputSelect = __webpack_require__(69858);
// EXTERNAL MODULE: ./components/Inputs/TextField.tsx
var TextField = __webpack_require__(46584);
// EXTERNAL MODULE: ./components/TofuOnbordingForms/dataMappers.ts
var dataMappers = __webpack_require__(78609);
// EXTERNAL MODULE: ./components/TofuOnbordingForms/utils.ts
var TofuOnbordingForms_utils = __webpack_require__(62408);
// EXTERNAL MODULE: ./ga.ts
var ga = __webpack_require__(83138);
// EXTERNAL MODULE: ./hooks/ielts/useDemoAlias.ts
var useDemoAlias = __webpack_require__(36728);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./page_routes/index.ts
var page_routes = __webpack_require__(12615);
// EXTERNAL MODULE: ./pages/ielts-preparation-online/ielts-elite-demo/index.tsx + 5 modules
var ielts_elite_demo = __webpack_require__(78314);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./scripts/segment.ts + 1 modules
var segment = __webpack_require__(83697);
// EXTERNAL MODULE: ./utils/common_utils.ts
var common_utils = __webpack_require__(92177);
// EXTERNAL MODULE: ./utils/event_utils.ts
var event_utils = __webpack_require__(59042);
// EXTERNAL MODULE: ./utils/events-utils.js
var events_utils = __webpack_require__(42477);
// EXTERNAL MODULE: ./utils/utm_utils.ts
var utm_utils = __webpack_require__(86147);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(66089);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/DebouncedSearchDropdown.tsx






var DebouncedSearchDropdown = function(param) {
    var value = param.value, onChange = param.onChange, fetchSuggestions = param.fetchSuggestions, _defaultSuggestions = param.defaultSuggestions, defaultSuggestions = _defaultSuggestions === void 0 ? [] : _defaultSuggestions, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Search..." : _placeholder, onBlur = param.onBlur, onFocus = param.onFocus;
    var ref = (0,react.useState)(value || ""), inputValue = ref[0], setInputValue = ref[1];
    var ref1 = (0,react.useState)([]), suggestions = ref1[0], setSuggestions = ref1[1];
    var ref2 = (0,react.useState)(false), showDropdown = ref2[0], setShowDropdown = ref2[1];
    var ref3 = (0,react.useState)(false), hasFocused = ref3[0], setHasFocused = ref3[1];
    var ref4 = (0,react.useState)(false), isFullScreen = ref4[0], setIsFullScreen = ref4[1];
    var ref5 = (0,react.useState)(""), additionalDialogs = ref5[0], setAdditionalDialogs = ref5[1];
    var inputRef = (0,react.useRef)(null);
    var cacheRef = (0,react.useRef)(new Map());
    var dropdownRef = (0,react.useRef)(null);
    var debouncedFetchRef = (0,react.useRef)(debounce_default()(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(query) {
            var ref, ref1, ref2, results;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(((ref = query.trim()) === null || ref === void 0 ? void 0 : ref.length) < 1)) {
                            _ctx.next = 6;
                            break;
                        }
                        setSuggestions(defaultSuggestions);
                        setShowDropdown(true);
                        setAdditionalDialogs("");
                        return _ctx.abrupt("return");
                    case 6:
                        if (!(((ref1 = query.trim()) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && ((ref2 = query.trim()) === null || ref2 === void 0 ? void 0 : ref2.length) < 3)) {
                            _ctx.next = 11;
                            break;
                        }
                        setAdditionalDialogs("Type min 3 letters");
                        setShowDropdown(false);
                        setSuggestions([]);
                        return _ctx.abrupt("return");
                    case 11:
                        setAdditionalDialogs("");
                        if (!cacheRef.current.has(query)) {
                            _ctx.next = 16;
                            break;
                        }
                        setSuggestions(cacheRef.current.get(query));
                        setShowDropdown(true);
                        return _ctx.abrupt("return");
                    case 16:
                        _ctx.next = 18;
                        return fetchSuggestions(query);
                    case 18:
                        results = _ctx.sent;
                        cacheRef.current.set(query, results);
                        setSuggestions(results);
                        if (results.length === 0) setAdditionalDialogs("No results found. Please search your nearest city.");
                        setShowDropdown(true);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(query) {
            return _ref.apply(this, arguments);
        };
    }(), 200));
    (0,react.useEffect)(function() {
        if (!hasFocused) return;
        debouncedFetchRef.current(inputValue);
        return function() {
            return debouncedFetchRef.current.cancel();
        };
    }, [
        inputValue,
        hasFocused
    ]);
    var handleSelect = function(item) {
        setInputValue(item);
        onChange(item);
        setShowDropdown(false);
        setIsFullScreen(false);
        setHasFocused(false);
    };
    var handleFocus = function() {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        setHasFocused(true);
        setIsFullScreen(true);
        if (inputValue.trim().length >= 3) {
            debouncedFetchRef.current(inputValue);
        } else {
            setSuggestions(defaultSuggestions);
            setShowDropdown(true);
        }
    };
    var renderSuggestions = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "overflow-y-auto max-h-full border border-[#DBDBDB] rounded",
            children: suggestions.map(function(item, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    onClick: function() {
                        return handleSelect(item);
                    },
                    className: "p-2 text-[#616161] hover:bg-[#736EFF] hover:text-white cursor-pointer ".concat(idx === suggestions.length - 1 ? "border-none" : "border-b", " border-[#DBDBDB]"),
                    children: item
                }, idx);
            })
        });
    };
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
                setIsFullScreen(false);
                setHasFocused(false);
                setAdditionalDialogs("");
                if (!suggestions.includes(inputValue)) {
                    setInputValue(value);
                }
                onBlur === null || onBlur === void 0 ? void 0 : onBlur();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        inputValue,
        suggestions,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: dropdownRef,
        className: styled_jsx_default().dynamic([
            [
                "ef74609474e654c4",
                [
                    isFullScreen ? "hidden" : "auto"
                ]
            ]
        ]) + " " + "relative w-full",
        children: [
            isFullScreen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "ef74609474e654c4",
                        [
                            isFullScreen ? "hidden" : "auto"
                        ]
                    ]
                ]) + " " + "fixed inset-0 bg-white z-50 flex flex-col p-4 md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://ik.imagekit.io/onsnhxjshmp/arrow_left_cyNOOe4ocQ.svg",
                        alt: "arrow",
                        height: 24,
                        width: 24,
                        onClick: function() {
                            setHasFocused(false);
                            setIsFullScreen(false);
                            setShowDropdown(false);
                            setAdditionalDialogs("");
                            if (!suggestions.includes(inputValue)) {
                                setInputValue(value);
                            }
                        },
                        className: styled_jsx_default().dynamic([
                            [
                                "ef74609474e654c4",
                                [
                                    isFullScreen ? "hidden" : "auto"
                                ]
                            ]
                        ])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: inputRef,
                        autoFocus: true,
                        type: "text",
                        value: inputValue,
                        onChange: function(e) {
                            var val = e.target.value;
                            setInputValue(val);
                        },
                        placeholder: placeholder,
                        onFocus: handleFocus,
                        className: styled_jsx_default().dynamic([
                            [
                                "ef74609474e654c4",
                                [
                                    isFullScreen ? "hidden" : "auto"
                                ]
                            ]
                        ]) + " " + "w-full mt-6 mb-3 z-20 p-2 border border-[#CBCAD5] rounded min-h-[44px] focus:border-primary text-[#616161] placeholder:text-[#A5A4B6]"
                    }),
                    additionalDialogs ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: styled_jsx_default().dynamic([
                            [
                                "ef74609474e654c4",
                                [
                                    isFullScreen ? "hidden" : "auto"
                                ]
                            ]
                        ]) + " " + "border-[0.5px] rounded -mt-4 p-3 border-[#E8E8E8] text-xs text-[#BDBDBD] text-center",
                        children: additionalDialogs
                    }) : showDropdown && suggestions.length > 0 && renderSuggestions()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: inputRef,
                type: "text",
                value: inputValue,
                onChange: function(e) {
                    var val = e.target.value;
                    setInputValue(val);
                },
                placeholder: placeholder,
                onFocus: handleFocus,
                className: styled_jsx_default().dynamic([
                    [
                        "ef74609474e654c4",
                        [
                            isFullScreen ? "hidden" : "auto"
                        ]
                    ]
                ]) + " " + "w-full p-2 z-20 border border-[#CBCAD5] rounded min-h-[44px] focus:border-primary text-[#616161] placeholder:text-[#A5A4B6]"
            }),
            additionalDialogs ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: styled_jsx_default().dynamic([
                    [
                        "ef74609474e654c4",
                        [
                            isFullScreen ? "hidden" : "auto"
                        ]
                    ]
                ]) + " " + "absolute w-full p-2 text-center z-10 text-[#BDBDBD] border border-[#DBDBDB] bg-white rounded shadow max-h-60 overflow-y-auto bottom-[100%] mb-1",
                children: additionalDialogs
            }) : showDropdown && suggestions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: styled_jsx_default().dynamic([
                    [
                        "ef74609474e654c4",
                        [
                            isFullScreen ? "hidden" : "auto"
                        ]
                    ]
                ]) + " " + "absolute w-full z-10 border border-[#DBDBDB] bg-white rounded shadow max-h-60 overflow-y-auto bottom-[100%] mb-1",
                children: suggestions.map(function(item, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        onClick: function() {
                            return handleSelect(item);
                        },
                        className: styled_jsx_default().dynamic([
                            [
                                "ef74609474e654c4",
                                [
                                    isFullScreen ? "hidden" : "auto"
                                ]
                            ]
                        ]) + " " + "p-2 text-[#616161] hover:bg-[#736EFF] hover:text-white cursor-pointer",
                        children: item
                    }, idx);
                })
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "ef74609474e654c4",
                dynamic: [
                    isFullScreen ? "hidden" : "auto"
                ],
                children: "@media only screen and (max-width:768px){body{overflow:".concat(isFullScreen ? "hidden" : "auto", "}}")
            })
        ]
    });
};
/* harmony default export */ var IeltsEliteProgressiveForm_DebouncedSearchDropdown = (DebouncedSearchDropdown);

;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/SearchDropDown.tsx



var SearchDropDown = function(param) {
    var input = param.input, meta = param.meta, fetchSuggestions = param.fetchSuggestions, defaultSuggestions = param.defaultSuggestions, placeholder = param.placeholder, handleInputChange = param.handleInputChange;
    var ref = (0,react.useState)(input.value || ""), selectedValue = ref[0], setSelectedValue = ref[1];
    var handleChange = function(val) {
        handleInputChange && handleInputChange(val);
        setSelectedValue(val);
        input.onChange(val);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IeltsEliteProgressiveForm_DebouncedSearchDropdown, {
                value: selectedValue,
                onChange: handleChange,
                fetchSuggestions: fetchSuggestions,
                placeholder: placeholder,
                defaultSuggestions: defaultSuggestions,
                onBlur: input.onBlur,
                onFocus: input.onFocus
            }),
            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mt-1 text-xs text-red-600",
                children: meta.error
            })
        ]
    });
};
/* harmony default export */ var IeltsEliteProgressiveForm_SearchDropDown = (SearchDropDown);

;// CONCATENATED MODULE: ./components/Ielts/IeltsOnboardingForms/IeltsEliteProgressiveForm/index.tsx












// local import


















var ieltsEliteDemoFormUseStyles = (0,makeStyles/* default */.Z)({
    root: {
        width: "100%",
        "& .MuiLinearProgress-colorPrimary": {
            backgroundColor: "transparent",
            height: "12px"
        },
        "& .MuiLinearProgress-barColorPrimary": {
            backgroundColor: "#7FBF7D",
            height: "12px"
        }
    }
});
var IeltsEliteProgressiveForm = function(param) {
    var isLoggedIn = param.isLoggedIn, loggedInNumber = param.loggedInNumber, formJson = param.formJson, prefilledData = param.prefilledData, onSubmitForm = param.onSubmitForm, isModal = param.isModal, formHeading = param.formHeading, buttonCta = param.buttonCta, _isMcFlow = param.isMcFlow, isMcFlow = _isMcFlow === void 0 ? false : _isMcFlow;
    var ref, ref1, ref2;
    var classes = ieltsEliteDemoFormUseStyles();
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(1), currentFormStep = ref3[0], setCurrentFormStep = ref3[1];
    var ref4 = (0,react.useState)(""), selectedCountry = ref4[0], setSelectedCountry = ref4[1];
    var ref5 = (0,react.useState)({}), duplicateFormValues = ref5[0], setDuplicateFormValues = ref5[1];
    var ref6 = (0,react.useState)({}), formValues = ref6[0], setFormValues = ref6[1];
    var ref7 = (0,react.useState)(false), isClickingBack = ref7[0], setIsClickingBack = ref7[1];
    var delayForStepChange = (0,react.useRef)(0);
    var _query = router.query, formStage = _query.formStage, slotId = _query.slotId, indexSlot = _query.indexSlot, isDisqualifiedUser = _query.isDisqualifiedUser, leadSourceFromQuery = _query.leadSource;
    var leadSource = Array.isArray(leadSourceFromQuery) ? leadSourceFromQuery[0] : leadSourceFromQuery;
    var isDisqualifiedUserFlow = isDisqualifiedUser === "true";
    var formDetailsObjectFromQuery = (0,ielts_elite_demo.getFilteredFormDataFromQueryObject)(router.query);
    var stage = (0,es/* useSelector */.v9)(function(state) {
        return state.spotCounselling.stage;
    });
    (0,react.useEffect)(function() {
        if (formStage === "2") {
            setCurrentFormStep(function(prev) {
                return prev + 1;
            });
        }
    }, [
        formStage
    ]);
    var isMasterclassAlias = (0,useDemoAlias/* default */.Z)().isMasterclassAlias;
    //Autonext logic
    (0,react.useEffect)(function() {
        (0,TofuOnbordingForms_utils/* autonextDecision */.hi)(duplicateFormValues, formJson, currentFormStep, setCurrentFormStep, isClickingBack);
        return function() {
            clearTimeout(delayForStepChange.current);
        };
    }, [
        duplicateFormValues
    ]);
    (0,react.useEffect)(function() {
        (0,TofuOnbordingForms_utils/* forceAutonextDecision */.qm)(formJson, currentFormStep, formValues, setCurrentFormStep, isClickingBack);
        if (currentFormStep === 2) {
            (0,segment.trackIeltsClick)(isMasterclassAlias ? events_utils.ieltsPageName.DEMO_MC_FORM_1 : events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_1, {
                contentName: "Next ",
                contentFormat: "Button",
                widgetName: "Inpage Form 1",
                widgetFormat: "Button"
            });
            (0,segment.trackPageV2)(isMasterclassAlias ? events_utils.ieltsPageName.DEMO_MC_FORM_2 : events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_2);
        }
    }, [
        currentFormStep
    ]);
    (0,react.useEffect)(function() {
        if (currentFormStep == 1) (0,segment.trackPageV2)(isMasterclassAlias ? events_utils.ieltsPageName.DEMO_MC_FORM_1 : events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_1, {
            optimizeSelection: "Base"
        });
        else (0,segment.trackPageV2)(isMasterclassAlias ? events_utils.ieltsPageName.DEMO_MC_FORM_2 : events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_2, {
            optimizeSelection: "Base"
        });
    }, []);
    (0,react.useEffect)(function() {
        if (isDisqualifiedUserFlow) {
            (0,segment.trackPageV2)(events_utils.ieltsPageName.IELTS_FORM_POST_BOOKING);
        }
    }, [
        isDisqualifiedUserFlow
    ]);
    var getCurrentFormId = function() {
        return (0,utils/* getFormId */.cY)(!!isDisqualifiedUser, isMasterclassAlias);
    };
    var handleSaveData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var domainName, utmDetails, newValues, utmObject, formValuesString, redirectURL, utmString, finalString;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        domainName = (0,TofuOnbordingForms_utils/* geturlToRedirect */.sV)();
                        utmDetails = (0,utm_utils/* getUtmData */.M)(null);
                        newValues = cloneDeep_default()(values);
                        newValues.utmSource = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "";
                        newValues.utmCampaign = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "";
                        newValues.gclid = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "";
                        newValues.adName = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "";
                        newValues.utmMedium = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium) || "";
                        newValues.utmTerm = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "";
                        newValues.campaignType = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.campaignType) || "";
                        newValues.adId = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "";
                        newValues.formId = getCurrentFormId();
                        newValues.leadSource = leadSource !== null && leadSource !== void 0 ? leadSource : utils/* LeadSources.OTHER */.e_.OTHER;
                        newValues.alias = router.query[utils/* demoAliasQueryConstant */.xj];
                        if (newValues === null || newValues === void 0 ? void 0 : newValues.name) {
                            newValues.name = (0,TofuOnbordingForms_utils/* nameExtraSpacetriming */.BX)(newValues === null || newValues === void 0 ? void 0 : newValues.name);
                        }
                        if (newValues === null || newValues === void 0 ? void 0 : newValues.howLeapHelp) {
                            newValues.howLeapHelp = newValues.howLeapHelp.join(",");
                        }
                        utmObject = {
                            utm_campaign: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign,
                            gclid: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid,
                            adName: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName,
                            utm_source: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource,
                            utm_term: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm,
                            utm_medium: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium,
                            campaign_type: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.campaignType,
                            ad_id: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId
                        };
                        if (loggedInNumber) {
                            newValues.phone = loggedInNumber;
                        }
                        if (!(newValues.whatCareerStage === "WORKING")) {
                            _ctx.next = 23;
                            break;
                        }
                        _ctx.next = 21;
                        return (0,ga.fireTagEvent)("Form Submitted Working", (0,_object_spread/* default */.Z)({}, newValues, utmObject));
                    case 21:
                        _ctx.next = 23;
                        return (0,segment.trackIeltsFormAsync)("Form Submitted Working", (0,_object_spread/* default */.Z)({}, newValues, utmObject));
                    case 23:
                        _ctx.next = 25;
                        return (0,segment.trackIeltsFormAsync)("Form Submitted", (0,_object_spread/* default */.Z)({}, newValues, utmObject));
                    case 25:
                        (0,event_utils/* handleFormSubmissionGaEventForm */.dk)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newValues), {
                            stage: stage
                        }), {
                            formType: "redirect",
                            formId: leadSource === (utils/* LeadSources */.e_ === null || utils/* LeadSources */.e_ === void 0 ? void 0 : utils/* LeadSources.MARKETING_DEMO_MC */.e_.MARKETING_DEMO_MC) ? "Ielts Demo MC Form" : "Ielts Demo Form"
                        });
                        formValuesString = (0,common_utils/* getQueryParamStringFromObject */.BX)(newValues);
                        redirectURL = "".concat(domainName, "/").concat(page_routes/* navRoutes.IELTS_DEMO_QL_PAGE */.CZ.IELTS_DEMO_QL_PAGE, "?prefilled_phone=").concat(newValues.phone, "&flowType=Elite Demo");
                        utmString = (0,common_utils/* getQueryParamStringFromObject */.BX)(utmObject);
                        finalString = redirectURL + utmString + formValuesString;
                        (0,common_utils/* redirectOutFromIframe */.Zm)(finalString);
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSaveData(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var savePersonalInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var ref, ref1, saveValue;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (currentFormStep == (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.length)) {
                            ;
                            saveValue = (0,_object_spread/* default */.Z)({}, prefilledData, values);
                            if ((formJson === null || formJson === void 0 ? void 0 : (ref1 = formJson.page_distribution) === null || ref1 === void 0 ? void 0 : ref1.length) == 1) {
                                (0,segment.trackIeltsClick)(isMasterclassAlias ? events_utils.ieltsPageName.DEMO_MC_FORM_1 : events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_1, {
                                    contentName: "Next ",
                                    contentFormat: "Button",
                                    widgetName: "Inpage Form 1",
                                    widgetFormat: "Button"
                                });
                            } else (0,segment.trackIeltsClick)(isMasterclassAlias ? events_utils.ieltsPageName.DEMO_MC_FORM_2 : events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_2, {
                                contentName: "Next",
                                contentFormat: "Button",
                                widgetName: "Inpage Form 2",
                                widgetFormat: "Button"
                            });
                            if (onSubmitForm) onSubmitForm(saveValue);
                            else handleSaveData(saveValue);
                        } else {
                            setCurrentFormStep(function(step) {
                                return step + 1;
                            });
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function savePersonalInfo(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRedirctingAB = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var domainName, utmDetails, newValues, utmObject, formValuesString, redirectURL, disqualifiedRedirectUrl, utmString, finalString;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        domainName = (0,TofuOnbordingForms_utils/* geturlToRedirect */.sV)();
                        utmDetails = (0,utm_utils/* getUtmData */.M)(null);
                        newValues = cloneDeep_default()(values);
                        newValues.utmSource = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource) || "";
                        newValues.utmCampaign = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign) || "";
                        newValues.gclid = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid) || "";
                        newValues.adName = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName) || "";
                        newValues.utmMedium = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium) || "";
                        newValues.utmTerm = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm) || "";
                        newValues.campaignType = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.campaignType) || "";
                        newValues.adId = (utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId) || "";
                        newValues.formId = getCurrentFormId();
                        newValues.leadSource = leadSource !== null && leadSource !== void 0 ? leadSource : utils/* LeadSources.OTHER */.e_.OTHER;
                        if (newValues === null || newValues === void 0 ? void 0 : newValues.name) {
                            newValues.name = (0,TofuOnbordingForms_utils/* nameExtraSpacetriming */.BX)(newValues === null || newValues === void 0 ? void 0 : newValues.name);
                        }
                        if (newValues === null || newValues === void 0 ? void 0 : newValues.howLeapHelp) {
                            newValues.howLeapHelp = newValues.howLeapHelp.join(",");
                        }
                        if (currentFormStep == 2) {
                            (0,segment.trackIeltsClick)(events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_2, {
                                contentName: "Next",
                                contentFormat: "Button",
                                widgetName: "Inpage Form 2",
                                widgetFormat: "Button"
                            });
                        } else {
                            (0,segment.trackIeltsClick)(events_utils.ieltsPageName.IELTS_ELITE_INPAGE_FORM_1, {
                                contentName: "Next ",
                                contentFormat: "Button",
                                widgetName: "Inpage Form 1",
                                widgetFormat: "Button"
                            });
                        }
                        utmObject = {
                            utm_campaign: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmCampaign,
                            utm_source: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmSource,
                            utm_term: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmTerm,
                            utm_medium: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.utmMedium,
                            gclid: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.gclid,
                            adName: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adName,
                            campaign_type: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.campaignType,
                            ad_id: utmDetails === null || utmDetails === void 0 ? void 0 : utmDetails.adId
                        };
                        if (!slotId) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 20;
                        return (0,segment.trackIeltsFormAsync)("Form Submitted", (0,_object_spread/* default */.Z)({}, newValues, utmObject));
                    case 20:
                        formValuesString = (0,common_utils/* getQueryParamStringFromObject */.BX)(newValues);
                        redirectURL = slotId ? "".concat(domainName, "/").concat(page_routes/* navRoutes.IELTS_ELITE_SLOTS_SCREEN */.CZ.IELTS_ELITE_SLOTS_SCREEN, "?flowType=Elite Demo&formStage=").concat(formStage || "1", "&slotId=").concat(slotId, "&indexSlot=").concat(indexSlot, "&abTest=true") : "".concat(domainName, "/").concat(page_routes/* navRoutes.IELTS_ELITE_SLOTS_SCREEN */.CZ.IELTS_ELITE_SLOTS_SCREEN, "?flowType=Elite Demo&formStage=").concat(formStage || "1", "&abTest=true");
                        disqualifiedRedirectUrl = slotId ? "".concat(domainName, "/").concat(page_routes/* navRoutes.IELTS_DEMO_FLOW_FOR_DISQUALIFIED_USERS */.CZ.IELTS_DEMO_FLOW_FOR_DISQUALIFIED_USERS, "?flowType=Elite Demo&formStage=2&slotId=").concat(slotId, "&indexSlot=").concat(indexSlot, "&changeHasBooked=true") : "".concat(domainName, "/").concat(page_routes/* navRoutes.IELTS_DEMO_FLOW_FOR_DISQUALIFIED_USERS */.CZ.IELTS_DEMO_FLOW_FOR_DISQUALIFIED_USERS, "?flowType=Elite Demo&formStage=2&changeHasBooked=true");
                        utmString = (0,common_utils/* getQueryParamStringFromObject */.BX)(utmObject);
                        finalString = (isDisqualifiedUser ? disqualifiedRedirectUrl : redirectURL) + utmString + formValuesString;
                        if (formStage === "2") (0,common_utils/* redirectOutFromIframe */.Zm)(finalString);
                        else window.open(finalString, "_self");
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleRedirctingAB(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var savePersonalInfoForABTest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var ref, saveValue;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (currentFormStep == (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.length)) {
                            saveValue = (0,_object_spread/* default */.Z)({}, prefilledData, values, formDetailsObjectFromQuery);
                            if (isDisqualifiedUserFlow) {
                                (0,segment.trackIeltsClick)(events_utils.ieltsPageName.IELTS_FORM_POST_BOOKING, {
                                    contentName: "Submit"
                                });
                            }
                            handleRedirctingAB(saveValue);
                        } else {
                            handleRedirctingAB(values);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function savePersonalInfoForABTest(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var getCtaText = (0,react.useCallback)(function() {
        if (currentFormStep) {
            var ref;
            if (currentFormStep == (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.page_distribution) === null || ref === void 0 ? void 0 : ref.length)) {
                if (buttonCta) return buttonCta;
                if (isDisqualifiedUser) return "Confirm Your Slot";
                return "Select MasterClass Slot";
            } else {
                return "NEXT";
            }
        }
    }, [
        currentFormStep
    ]);
    var RenderFields = function(param) {
        var component_type = param.component_type, question_text = param.question_text, options = param.options, validation = param.validation, fieldValue = param.fieldValue, label = param.label, default_visibility = param.default_visibility, visibility_dependency = param.visibility_dependency, values = param.values, numGridColumns = param.numGridColumns, question_id = param.question_id, _isMultiSelect = param.isMultiSelect, isMultiSelect = _isMultiSelect === void 0 ? false : _isMultiSelect, _maxSelect = param.maxSelect, maxSelect = _maxSelect === void 0 ? 1 : _maxSelect, fetchSuggestions = param.fetchSuggestions, defaultSuggestions = param.defaultSuggestions;
        var ref;
        var isThisFieldVisible = true;
        for(var i = 0; i < (visibility_dependency === null || visibility_dependency === void 0 ? void 0 : (ref = visibility_dependency.dependencies) === null || ref === void 0 ? void 0 : ref.length); i++){
            var ref1, ref2, ref3;
            if ((ref1 = visibility_dependency === null || visibility_dependency === void 0 ? void 0 : visibility_dependency.dependencies[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.includes(values[(0,TofuOnbordingForms_utils/* getDependentQuestionFieldName */.KB)(formJson, (ref3 = visibility_dependency === null || visibility_dependency === void 0 ? void 0 : visibility_dependency.dependencies[i]) === null || ref3 === void 0 ? void 0 : ref3.question_id)])) {
                continue;
            } else {
                isThisFieldVisible = false;
                break;
            }
        }
        if (isThisFieldVisible || default_visibility) switch(component_type){
            case "single_select_tile":
                {
                    var ref4;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            question_id === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "my-4",
                                        children: formHeading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: formHeading
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingIeltsElite/* default */.Z, {})
                                    }),
                                    !isModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "bg-[#EDEEFF] border-[#EDEEFF] md:min-w-[100vw] md:ml-[-28vw] border-[1px] mt-12"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center text-gray-170 md:text-font24 font-bold ".concat(question_id === 1 && !isMcFlow ? "pt-[48px]" : null),
                                children: question_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:px-7 md:py-2 px-1 py-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: fieldValue,
                                    label: label,
                                    component: CustomInputSelect/* default */.Z,
                                    options: options,
                                    isMultiSelect: isMultiSelect,
                                    maxSelect: maxSelect,
                                    numGridColumns: numGridColumns !== null && numGridColumns !== void 0 ? numGridColumns : null,
                                    validate: function(v) {
                                        if (fieldValue === "preferredCountry") setSelectedCountry(v);
                                        if ((formJson === null || formJson === void 0 ? void 0 : formJson.required.includes(fieldValue)) && !v) return "This is a mandatory field";
                                        if (v && isMultiSelect) return (0,TofuOnbordingForms_utils/* validateHowToHelpVal */.Pl)(v, maxSelect);
                                    },
                                    onClick: function(e) {
                                        setIsClickingBack(false);
                                        if (!isMultiSelect && (formJson === null || formJson === void 0 ? void 0 : formJson.is_auto_progressive)) {
                                            delayForStepChange.current = window.setTimeout(function() {
                                                var ref;
                                                setDuplicateFormValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, duplicateFormValues), (0,_define_property/* default */.Z)({}, fieldValue, e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value)));
                                            }, 200);
                                        }
                                    },
                                    nudgeOption: formJson === null || formJson === void 0 ? void 0 : (ref4 = formJson.intakeReccomendationNudge) === null || ref4 === void 0 ? void 0 : ref4.filter(function(elem) {
                                        return elem.country === values.preferredCountry;
                                    })[0]
                                })
                            })
                        ]
                    });
                }
            case "searchInput":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center text-gray-170 md:text-font24 font-bold ".concat(question_id === 1 ? "pt-[48px]" : null),
                                children: question_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:px-[36px] md:py-2 px-3 py-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: fieldValue,
                                    component: IeltsEliteProgressiveForm_SearchDropDown,
                                    fetchSuggestions: fetchSuggestions,
                                    defaultSuggestions: defaultSuggestions,
                                    placeholder: label,
                                    validate: function(v) {
                                        if (!v) return "Please select a city";
                                    },
                                    handleInputChange: function(val) {
                                        (0,segment.trackEventAsync)("Click", {
                                            contentName: "Ielts City Search",
                                            city: val,
                                            formid: "IELTS Demo Form"
                                        });
                                    }
                                })
                            })
                        ]
                    });
                }
            case "numberInput":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center text-gray-170 md:text-font24 font-bold ".concat(question_id === 1 ? "pt-[48px]" : null),
                                children: question_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:px-7 md:py-2 px-4 py-2 w-full md:w-4/5 md:mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: fieldValue,
                                    component: TextField/* default */.Z,
                                    placeholder: label,
                                    label: "label",
                                    type: "number",
                                    validate: function(v) {
                                        if ((formJson === null || formJson === void 0 ? void 0 : formJson.required.includes(fieldValue)) && !v) return "This is a mandatory field";
                                        if (v && validation.pattern) {
                                            var regex = new RegExp(validation === null || validation === void 0 ? void 0 : validation.pattern);
                                            if (!regex.test(v)) return validation.errorMessage;
                                        }
                                    }
                                })
                            })
                        ]
                    });
                }
            case "textInput":
                {
                    if (fieldValue === "phone" && !isLoggedIn || fieldValue !== "phone") return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            question_id === 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "my-4",
                                        children: formHeading ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingIeltsElite/* default */.Z, {})
                                    }),
                                    !isModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "bg-[#EDEEFF] border-[#EDEEFF] md:min-w-[100vw] md:ml-[-28vw] border-[1px] mt-12"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center text-gray-170 md:text-font24 font-bold ".concat(question_id === 1 ? "pt-[48px]" : null),
                                children: question_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(question_id === 11 ? "md:mt-4 mt-2" : null),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:px-7 md:py-2 px-4 py-2 my-4 w-full md:w-4/5 md:mx-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                        name: fieldValue,
                                        component: TextField/* default */.Z,
                                        placeholder: label,
                                        label: label,
                                        type: "text",
                                        validate: function(v) {
                                            if ((formJson === null || formJson === void 0 ? void 0 : formJson.required.includes(fieldValue)) && !v) return "This is a mandatory field";
                                            if (v && !v.trim()) return "Please enter correct answer";
                                            if (v && validation.pattern) {
                                                var regex = new RegExp(validation === null || validation === void 0 ? void 0 : validation.pattern);
                                                if (!regex.test(v)) return validation.errorMessage;
                                            }
                                        }
                                    })
                                })
                            })
                        ]
                    });
                }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((LeadCaptureLayout_module_default()).wrapperLeadCapture, " ").concat(isMcFlow ? "!min-h-[512px]" : "", " "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(classes.root),
                    children: [
                        currentFormStep == 2 && (formJson === null || formJson === void 0 ? void 0 : (ref = formJson.required) === null || ref === void 0 ? void 0 : ref.includes("preferredCountry")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-primary py-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center text-white text-sm font-bold",
                                children: "".concat(dataMappers/* intakeValueToLabel */.MW[formJson === null || formJson === void 0 ? void 0 : (ref1 = formJson.intakeReccomendationNudge) === null || ref1 === void 0 ? void 0 : ref1.find(function(elem) {
                                    return elem.country === selectedCountry;
                                }).intake], " has a higher acceptance rate")
                            })
                        }),
                        !isMcFlow && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
                            variant: "determinate",
                            value: Math.round(currentFormStep / (formJson === null || formJson === void 0 ? void 0 : (ref2 = formJson.page_distribution) === null || ref2 === void 0 ? void 0 : ref2.length) * 100)
                        })
                    ]
                }),
                currentFormStep > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-row mx-auto text-gray-1741 flex items-center pt-4 md:pl-0 pl-2 cursor-pointer",
                    onClick: function() {
                        setCurrentFormStep(function(step) {
                            return step - 1;
                        });
                        setDuplicateFormValues({});
                        setIsClickingBack(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/back_arrow1.svg"),
                            alt: "",
                            width: "30px",
                            height: "30px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-font16 hidden md:inline-block pl-2",
                            children: "BACK"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-between ".concat((LeadCaptureLayout_module_default()).wrapperLeadCapture, " ").concat(isMcFlow ? "!min-h-[512px] py-6" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (LeadCaptureLayout_module_default()).fieldsContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                                onSubmit: isDisqualifiedUserFlow ? savePersonalInfoForABTest : savePersonalInfo,
                                initialValues: prefilledData,
                                children: function(param) {
                                    var handleSubmit = param.handleSubmit, values = param.values, submitting = param.submitting;
                                    setFormValues(values);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                onSubmit: handleSubmit,
                                                noValidate: true,
                                                children: formJson === null || formJson === void 0 ? void 0 : formJson.fields.slice((0,TofuOnbordingForms_utils/* indexCal */.e2)(formJson, currentFormStep)[0], (0,TofuOnbordingForms_utils/* indexCal */.e2)(formJson, currentFormStep)[1]).map(function(field) {
                                                    var type = field.type, options = field.options, question_text = field.question_text, fieldValue = field.fieldValue, label = field.label, validation = field.validation, default_visibility = field.default_visibility, visibility_dependency = field.visibility_dependency, numGridColumns = field.numGridColumns, question_id = field.question_id, isMultiSelect = field.isMultiSelect, maxSelect = field.maxSelect, fetchSuggestions = field.fetchSuggestions, defaultSuggestions = field.defaultSuggestions;
                                                    return RenderFields({
                                                        component_type: type,
                                                        question_text: question_text,
                                                        options: options,
                                                        validation: validation,
                                                        // onClick,
                                                        fieldValue: fieldValue,
                                                        label: label,
                                                        default_visibility: default_visibility,
                                                        visibility_dependency: visibility_dependency,
                                                        values: values,
                                                        numGridColumns: numGridColumns,
                                                        question_id: question_id,
                                                        isMultiSelect: isMultiSelect,
                                                        maxSelect: maxSelect,
                                                        fetchSuggestions: fetchSuggestions,
                                                        defaultSuggestions: defaultSuggestions
                                                    });
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full flex justify-center mt-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: "bg-primary py-3 rounded text-white flex justify-center w-4/5 md:w-3/5 mx-auto my-4 items-center",
                                                    onClick: function() {
                                                        handleSubmit();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "pr-2 md:text-font16 font-bold",
                                                            children: submitting ? "SAVING..." : getCtaText()
                                                        }),
                                                        !submitting && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/practice_tab/whitearrow.svg"),
                                                            className: "scale-125"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/lead-capture/background-illustration.svg"),
                            className: "bottom-0 hidden md:block -z-1 md:absolute"
                        }),
                        !isMcFlow && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/lead-capture/background-illustration-mobile.svg"),
                            className: "bottom-0 md:hidden w-full -z-1"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var IeltsOnboardingForms_IeltsEliteProgressiveForm = (IeltsEliteProgressiveForm);


/***/ }),

/***/ 69858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Inputs_CustomInputSelect; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(66089);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
;// CONCATENATED MODULE: ./components/Inputs/CustomInputSelectionCheckbox.tsx




var CustomInputSelectionCheckbox = function(param) {
    var label = param.label, input = param.input, icon = param.icon, onClick = param.onClick, setValue = param.setValue, isPlannerComponent = param.isPlannerComponent, isMultiSelect = param.isMultiSelect, nudgeThisOption = param.nudgeThisOption, fieldValue = param.fieldValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-ce9db8402540916f" + " " + "flex justify-center items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: "jsx-ce9db8402540916f" + " " + "flex md:py-2 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        onClick: function() {
                            if (setValue) {
                                setValue(label);
                            }
                        },
                        className: "jsx-ce9db8402540916f" + " " + "".concat(isPlannerComponent && isMultiSelect && "radio-label", " checkbox-label  m-9 w-full"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                type: "checkbox"
                            }, input), {
                                onClick: onClick,
                                className: "jsx-ce9db8402540916f" + " " + "".concat(isPlannerComponent ? "checkbox-round" : "")
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-ce9db8402540916f" + " " + "checkbox-custom rectangular"
                            }),
                            label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-ce9db8402540916f" + " " + "bg-white rounded text-font14 text-center md:pr-4 md:pl-4 px-2 grid flex-col items-center bold input-reaction cursor-pointer ".concat(typeof icon == "string" || isPlannerComponent ? "input-with-icon" : "input-without-icon  ".concat([
                                    "preferredCountry",
                                    "preferredIntake"
                                ].includes(fieldValue || "") ? "xs:w-[104px] w-[98px] " : "w-full")),
                                children: [
                                    nudgeThisOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            top: "-12px"
                                        },
                                        className: "jsx-ce9db8402540916f" + " " + "absolute font-bold bg-green-1900 px-2 md:px-3 rounded-lg flex justify-center w-[94px] md:w-[134px] left-0 right-0 mx-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "jsx-ce9db8402540916f" + " " + "mr-1 text-green-1751 text-[10px] md:text-xs",
                                                children: "Recommended"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/green_dot.svg"),
                                                alt: "icon",
                                                className: "jsx-ce9db8402540916f"
                                            })
                                        ]
                                    }),
                                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: icon,
                                        alt: "logo",
                                        className: "jsx-ce9db8402540916f" + " " + "flag-img"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-ce9db8402540916f" + " " + "".concat(typeof icon == "string" ? "" : "md:py-0 py-0 my-auto mx-0", " leading-none md:w-auto text-lightgray-800 text-center text-font14 md:text-font16 w-full ").concat(isPlannerComponent && "whitespace-nowrap"),
                                        children: label
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (0,jsx_runtime.jsx)((styled_jsx_default()), {
                    id: "ce9db8402540916f",
                    children: 'checkbox-container.jsx-ce9db8402540916f{float:left;width:50%;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;text-align:center;padding:90px 0px;border:1px solid red}.radio-label.jsx-ce9db8402540916f input.jsx-ce9db8402540916f{position:absolute;opacity:1!important;cursor:pointer;right:0px;margin:5px!important;-webkit-transform:scale(1.1);-moz-transform:scale(1.1);-ms-transform:scale(1.1);-o-transform:scale(1.1);transform:scale(1.1)}.checkbox-round.jsx-ce9db8402540916f{width:.7em;height:.7em;background-color:white;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;vertical-align:middle;border:1px solid#ddd;-moz-appearance:none;-ms-appearance:none;appearance:none;-webkit-appearance:none;outline:none;cursor:pointer}.checkbox-round.jsx-ce9db8402540916f:checked{background-position-x:-.5px;background-image:url(process.env.CDN_URL + "/assets/images/planner/radio-tick.svg");background-color:#443eff}.radio-label.jsx-ce9db8402540916f input[type="checkbox"].jsx-ce9db8402540916f{-webkit-border-radius:50%!important;-moz-border-radius:50%!important;border-radius:50%!important;display:hidden!important}.checkbox-label.jsx-ce9db8402540916f{display:block;position:relative;cursor:pointer;font-size:22px;line-height:24px;clear:both}.checkbox-label.jsx-ce9db8402540916f input.jsx-ce9db8402540916f{position:absolute;opacity:0;cursor:pointer}.checkbox-label.jsx-ce9db8402540916f .input-reaction.jsx-ce9db8402540916f{border:1px solid#bdbdbd}.checkbox-label.jsx-ce9db8402540916f input.jsx-ce9db8402540916f:checked~.input-reaction.jsx-ce9db8402540916f{background-color:#e3e4ff;border:2px solid#494fe3}.flag-img.jsx-ce9db8402540916f{height:24px;width:36.63px;margin:0 auto}@media only screen and (max-device-width:768px){.input-with-icon.jsx-ce9db8402540916f{width:96px;height:72px;padding:10px 0px}}@media only screen and (min-device-width:769px){.input-with-icon.jsx-ce9db8402540916f{width:180px;height:100px;padding:16px 0px}}@media only screen and (max-device-width:768px){.input-without-icon.jsx-ce9db8402540916f{min-height:48px}}@media only screen and (min-device-width:769px){.input-without-icon.jsx-ce9db8402540916f{width:180px;height:48px}.input-without-icon-planner.jsx-ce9db8402540916f{width:180px;height:120px}}'
                })
            ]
        })
    });
};
/* harmony default export */ var Inputs_CustomInputSelectionCheckbox = (CustomInputSelectionCheckbox);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
;// CONCATENATED MODULE: ./components/Inputs/CustomInputSelect.tsx




var CustomInputSelect = function(param) {
    var input = param.input, options = param.options, meta = param.meta, isMultiSelect = param.isMultiSelect, subText = param.subText, numGridColumns = param.numGridColumns, onClick = param.onClick, setValue = param.setValue, isPlannerComponent = param.isPlannerComponent, nudgeOption = param.nudgeOption, fieldValue = param.fieldValue;
    var gridColCssStr = (0,react.useMemo)(function() {
        return numGridColumns ? "grid-cols-2 md:grid-cols-".concat(numGridColumns, " ").concat(isPlannerComponent ? "w-fit" : "") : [
            "preferredCountry",
            "preferredIntake"
        ].includes(fieldValue || "") ? "" : "grid-cols-3";
    }, [
        numGridColumns,
        fieldValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-lightgray-800 text-font14 md:text-base",
                children: subText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat([
                    "preferredCountry",
                    "preferredIntake"
                ].includes(fieldValue || "") ? "flex flex-wrap justify-center" : "grid", " ").concat(gridColCssStr),
                children: options.map(function(option, i) {
                    var label = option.label, value = option.value, icon = option.icon;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: isPlannerComponent ? "flex justify-center align-middle items-center" : '"mx-auto '.concat(numGridColumns == 2 ? "md:first:justify-self-end" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: input.name,
                            component: Inputs_CustomInputSelectionCheckbox,
                            type: isMultiSelect ? "checkbox" : "radio",
                            value: value,
                            isMultiSelect: isMultiSelect,
                            label: label,
                            icon: icon,
                            isPlannerComponent: isPlannerComponent,
                            optionSize: options.length,
                            onClick: onClick,
                            setValue: setValue,
                            nudgeThisOption: nudgeOption ? nudgeOption.intake == value : false,
                            fieldValue: fieldValue
                        })
                    }, i);
                })
            }),
            meta.touched && meta.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-1 text-xs text-red-600 ".concat(isPlannerComponent ? "md:pl-8 pl-4" : "md:pl-2 pl-4"),
                children: meta.error
            })
        ]
    });
};
/* harmony default export */ var Inputs_CustomInputSelect = (CustomInputSelect);


/***/ }),

/***/ 78609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JK": function() { return /* binding */ anyCountryToValueCountry; },
/* harmony export */   "MW": function() { return /* binding */ intakeValueToLabel; },
/* harmony export */   "Vl": function() { return /* binding */ intakeValueToLabelDynamic; }
/* harmony export */ });
/* unused harmony exports selectedCourseValueTextMapper, selectedIntakeValueTextMapper */
var selectedCourseValueTextMapper = {
    POST_GRADUATE_DIPLOMA: "PG Diploma",
    MASTERS: "Masters",
    UNDER_GRADUATION: "UG course",
    MBA: "MBA",
    PHD: "PHD",
    NOT_DECIDED: "Course not decided"
};
var selectedIntakeValueTextMapper = {
    SEPTEMBER_2021: "Sept 2021",
    JANUARY_2022: "Jan 2022",
    YEAR_2024: "Year 2024",
    YEAR_2023: "2023"
};
var intakeValueToLabel = {
    "JAN_2023": "January 2023",
    "SEP_2023": "September 2023",
    "YEAR_2024": "Year 2024",
    "JAN_2024": "January 2024",
    "SEP_2024": "September 2024"
};
var intakeValueToLabelDynamic = {
    "JAN": "January",
    "SEP": "September",
    "MAY": "May",
    "NOVEMBER": "November",
    "JULY": "July",
    "FEBRUARY": "February"
};
var anyCountryToValueCountry = {
    "canada": "Canada",
    "Canada": "Canada",
    "CANADA": "Canada",
    "Ireland": "Ireland",
    "ireland": "Ireland",
    "IRELAND": "Ireland",
    "Australia": "Australia",
    "australia": "Australia",
    "AUSTRALIA": "Australia",
    "UK": "UK",
    "uk": "UK",
    "Uk": "UK",
    "USA": "USA",
    "usa": "USA",
    "Uas": "USA",
    "Other": "Other",
    "other": "Other",
    "OTHER": "Other"
};


/***/ })

}]);